import "./ClockIn.css";

import { Button, Checkbox, TextField } from "@mui/material";
import { useState } from "react"
import { ClockInStatus, TailorService } from "../../sojoApi";

const greetingFromDate = (date: Date): string => {
    const hour = date.getHours();
    if (hour < 12) {
        return "morning";
    } else if (hour < 18) {
        return "afternoon";
    } else {
        return "evening";
    }
}

const secondsSinceDate = (date: number): number => {
    const now = new Date();
    const utcDateNow = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(),
        now.getUTCDate(), now.getUTCHours(),
        now.getUTCMinutes(), now.getUTCSeconds());
    return (utcDateNow - date) / 1000;
}

const timeSinceDateAsString = (date: number): string => {
    let secondsSince = secondsSinceDate(date);
    const hours = Math.floor(secondsSince / 3600);
    secondsSince %= 3600;
    const minutes = Math.floor(secondsSince / 60);
    return `${hours} hours and ${minutes} minutes`
}

export const ClockIn = () => {
    const [accessCode, setAccessCode] = useState<string>();
    const [tailor, setTailor] = useState<ClockInStatus>();
    const [lunchTaken, setLunchTaken] = useState(true);

    return (<div className="centre-middle">
        <h1>Tailor clock in/out system</h1>
        {tailor ? null : <>
            <TextField className="access-code-input" onChange={(e) => setAccessCode(e.target.value)} label="Enter your access code" autoComplete="off" type="number"></TextField>
            <Button
                style={{ marginTop: "20px" }}
                variant="contained"
                disabled={!accessCode}
                onClick={() => {
                    TailorService.clockInStatusTailorClockInStatusGet(accessCode || "").then((result) => {
                        setTailor(result);
                    }).catch((err) => {
                        console.error(err);
                        alert("Login failed. Please check your access code.")
                    });
                }}
            >
                Enter
            </Button>
        </>}
        {tailor ? <div>
            <h2>Good {greetingFromDate(new Date())}, {tailor.tailor.name}!</h2>
            <h3>You are currently{" "}
                <span className={tailor.tailor.is_clocked_in ? "clocked-in" : "clocked-out"}>
                    clocked {tailor.tailor.is_clocked_in ? "in" : "out"}.
                </span>
            </h3>
            {tailor.tailor.is_clocked_in ? <p>You have been clocked in for {timeSinceDateAsString(Date.parse(`${tailor.current_shift?.clock_in}+00:00` || ""))}.</p> : null}
            {tailor.tailor.is_clocked_in ? <>
                <span>Lunch taken?</span>
                <Checkbox checked={lunchTaken} onChange={(e) => setLunchTaken(e.target.checked)} />
            </> : null}
            {tailor.tailor.is_clocked_in && secondsSinceDate(Date.parse(`${tailor.current_shift?.clock_in}+00:00` || "")) > 12 * 60 * 60 ? <span className="clocked-out">
                WARNING: You have been clocked in for over 12 hours. If you forget to clock out of your last shift, please notify your manager.
            </span> : null}
            <div className="dual-buttons" style={{ width: "300px", margin: "20px auto" }}>
                <Button
                    variant="contained"
                    disabled={!accessCode}
                    className="exit-button"
                    onClick={() => {
                        setTailor(undefined);
                    }}
                >
                    Exit
                </Button>
                <Button
                    variant="contained"
                    className="clock-in-page-button"
                    disabled={!accessCode}
                    onClick={() => {
                        if (!tailor.tailor.is_clocked_in) {
                            TailorService.clockInTailorClockInPost(tailor.tailor._id).then((result) => {
                                alert(`Successfully clocked in at ${new Date().toTimeString()}`);
                                setTailor(undefined);
                            }).catch((err) => {
                                console.error(err);
                                alert("An unknown error occurred.")
                            });
                        } else {
                            TailorService.clockOutTailorClockOutPost(tailor.tailor._id, lunchTaken).then((result) => {
                                alert(`Successfully clocked out at ${new Date().toTimeString()}`);
                                setTailor(undefined);
                            }).catch((err) => {
                                console.error(err);
                                alert("An unknown error occurred.")
                            });
                        }
                    }}
                >
                    Clock {tailor.tailor.is_clocked_in ? "out" : "in"} now
                </Button>
            </div>
        </div> : null}
    </div>)
}